import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { EQUIPMENT_CATALOGS_CRUD_ACTION_CREATORS } from '../actions/equipment_catalogs_actions';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';
import { message } from 'antd';

const fetchUtils = new FetchUtils();
const BASE_URL = getBackendUri();

export const equipmentCatalogsRestCrudThunksForSupplier = new RestCrudThunks(
	'equipment_catalogs',
	'equipment_catalog',
	'equipmentCatalog',
	'equipmentCatalogs',
	EQUIPMENT_CATALOGS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'inventory/'
);

export const replaceEquipmentVendorsForSupplier = (equipmentTypeId, entities) => {
	const apiUrl = `/api/v1/supplier/inventory/equipment_catalogs/replace_vendors_without_cost_update`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.patch(BASE_URL + apiUrl + `/${equipmentTypeId}`, {
					data: entities,
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				})
				.then((response) => response.json())
				.then((d) => {
					if (d.status === 'error') {
						dispatch(
							EQUIPMENT_CATALOGS_CRUD_ACTION_CREATORS.updateError(d.message, equipmentTypeId)
						);
						reject(d.message);
					} else {
						dispatch(EQUIPMENT_CATALOGS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(EQUIPMENT_CATALOGS_CRUD_ACTION_CREATORS.updateError(d.message, equipmentTypeId));
					reject(d.message);
				});
		});
	};
};

const updateEquipmentCatalogsListPrice = (roleType) => (data) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/inventory/equipment_catalogs/update_list_prices`;

	// if sorting present, fix order naming and add to query params

	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(EQUIPMENT_CATALOGS_CRUD_ACTION_CREATORS.updateStart({}));

			fetchUtils
				.put(
					baseUrl + apiUrl,
					Object.assign({
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data,
					})
				)
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(EQUIPMENT_CATALOGS_CRUD_ACTION_CREATORS.updateError(d.message, {}));
						reject(d.message);
					} else {
						dispatch(EQUIPMENT_CATALOGS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(EQUIPMENT_CATALOGS_CRUD_ACTION_CREATORS.updateError(d.message, {}));
					reject(d.message);
				});
		});
	};
};

export const updateEquipmentCatalogsListPriceForBuyer = updateEquipmentCatalogsListPrice(
	ROLE_TYPES.BUYER
);
export const updateEquipmentCatalogsListPriceForSupplier = updateEquipmentCatalogsListPrice(
	ROLE_TYPES.SUPPLIER
);

const downloadEquipmentCatalogPriceCSV =
	(roleType) =>
	(params, filters = null) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/inventory/equipment_catalogs/csv_report_generator`;

		// if sorting present, fix order naming and add to query params

		if (filters) {
			params = {
				...params,
				...filters,
			};
		}

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				fetchUtils
					.get(
						baseUrl + apiUrl,
						Object.assign(
							{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
							params
						)
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
							message.error(d.data);
						} else {
							resolve(d.data);
							const hide = message.loading(d.data, 0);
							setTimeout(hide, 7000);
						}
					})
					.catch((d) => {
						reject(d.message);
					});
			});
		};
	};

export const downloadEquipmentCatalogPriceCSVForSupplier = downloadEquipmentCatalogPriceCSV(
	ROLE_TYPES.SUPPLIER
);
